
function PublicLayout({ children }: any) {

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
      {/* <!-- ===== Sidebar Start ===== --> */}

        {/* <!-- ===== Main Content Start ===== --> */}
        <main>
          <div className="mx-auto p-4 md:p-6 2xl:p-10">
            {children}
          </div>
        </main>
    </div>
  );
}

export default PublicLayout;
